import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { StammdatenComponent } from './stammdaten.component';
import { ArtikelDialogComponent } from './dialog-artikel/dialog-artikel.component';
import { DialogMassnahmeComponent } from './dialog-massnahme/dialog-massnahme.component';
import { DialogAbweichungComponent } from './dialog-abweichung/dialog-abweichung.component';

@NgModule({
  declarations: [
    StammdatenComponent,
    ArtikelDialogComponent,
    DialogMassnahmeComponent,
    DialogAbweichungComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCardModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatTabsModule,
    MatProgressSpinnerModule,
  ],
  providers: [],
})
export class StammdatenModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    const stammdatenElement = createCustomElement(StammdatenComponent, {
      injector: this.injector,
    });
    customElements.define('app-stammdaten', stammdatenElement);
  }
}
